import { BasePersonalFinancialStatementResource, PersonalFinancialStatementResourceType } from './basePersonalFinancialStatementResource'
import { getMonthlySpendingComparisonData } from '@/services/personalFinancialStatement'
import { log } from '@/utils/logger'
import { MonthlySpendingComparsionData } from 'aven_types'

export class PersonalFinancialStatementMonthlySpendingComparisonResource extends BasePersonalFinancialStatementResource<PersonalFinancialStatementResourceType.MONTHLY_SPENDING_COMPARISON> {
    constructor() {
        super(PersonalFinancialStatementResourceType.MONTHLY_SPENDING_COMPARISON)
    }

    protected async fetchData(): Promise<MonthlySpendingComparsionData | null> {
        log.info('PersonalFinancialStatementMonthlySpendingComparisonResource.fetchData: Fetching monthly spending comparison data')

        const response = await getMonthlySpendingComparisonData()

        if (response.data.success) {
            const { previousMonthSpendingCents, currentMonthSpendingCents, currentDaySpendingDifferenceCents, sourceInstitutionNames } = response.data.payload

            log.info('PersonalFinancialStatementMonthlySpendingComparisonResource.fetchData: Fetched %{prevCount} previous month data points and %{currCount} current month data points', {
                prevCount: previousMonthSpendingCents.length,
                currCount: currentMonthSpendingCents.length,
            })

            return {
                previousMonthSpendingCents,
                currentMonthSpendingCents,
                currentDaySpendingDifferenceCents,
                sourceInstitutionNames,
            }
        } else {
            log.warn('PersonalFinancialStatementMonthlySpendingComparisonResource.fetchData: No data returned from API')
            return null
        }
    }
}
